import React from 'react';
const NotFound = () => <div>Loading...</div>;
export default NotFound;